// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `group-scoreboard * {
  box-sizing: border-box;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
group-scoreboard * ::-webkit-scrollbar {
  display: none;
}
group-scoreboard .simple-select {
  display: flex;
}
group-scoreboard .simple-select .overlay-container {
  width: 100%;
  max-height: 100%;
  margin-top: 0;
}
group-scoreboard .simple-select .select-box {
  max-height: 90vh;
}
group-scoreboard .simple-select hr {
  display: none;
}
group-scoreboard h3,
group-scoreboard span.subheading {
  text-align: center;
  margin-bottom: 1rem;
}
group-scoreboard h3 {
  text-transform: uppercase;
}
group-scoreboard h3::after {
  content: "";
  display: block;
  margin: auto;
  width: 30%;
  padding-top: 0.5rem;
  border-bottom: 2px solid var(--motes-highlight-color);
}
group-scoreboard span.subheading {
  display: block;
}
group-scoreboard .waiting-box {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 45%;
  font-size: 18px;
  left: 0;
  right: 0;
  --animation-time: 2.7s;
}
group-scoreboard .waiting-box .persons-loading {
  display: flex;
  position: relative;
  justify-content: center;
  font-size: 34px;
  margin-bottom: 2px;
  animation: loading-people-out var(--animation-time) ease-out infinite;
  animation-fill-mode: forwards;
}
group-scoreboard .waiting-box .persons-loading svg-icon {
  transform: translateY(15px);
  position: relative;
}
group-scoreboard .waiting-box .waiting-label {
  text-align: center;
}
group-scoreboard .waiting-box .persons-loading svg-icon:nth-child(1) {
  animation: loading-people-in var(--animation-time) ease-in-out infinite;
  animation-delay: 0ms;
  animation-fill-mode: both;
}
group-scoreboard .waiting-box .persons-loading svg-icon:nth-child(2) {
  animation: loading-people-in var(--animation-time) ease-in-out infinite;
  animation-delay: 450ms;
  animation-fill-mode: both;
}
group-scoreboard .waiting-box .persons-loading svg-icon:nth-child(3) {
  animation: loading-people-in var(--animation-time) ease-in-out infinite;
  animation-delay: 900ms;
  animation-fill-mode: both;
}
@keyframes loading-people-in {
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  8% {
    opacity: 1;
  }
  10% {
    transform: translateY(0px);
    opacity: 1;
  }
  65% {
    opacity: 1;
    transform: translateY(0px);
  }
  66% {
    opacity: 0;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(0px);
  }
}
@keyframes loading-people-out {
  0% {
    opacity: 1;
    transform: translateY(0px);
  }
  60% {
    transform: translateY(0px);
    opacity: 1;
  }
  70% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 0;
    transform: translateY(12px);
  }
}
group-scoreboard scoreboard-column {
  height: 30vh;
}
group-scoreboard .scoreboard {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  scroll-behavior: smooth;
  margin: auto;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
}
group-scoreboard .score {
  width: min(25vw, 100px);
  flex-shrink: 0;
  margin-left: min(2vw, 1em);
  margin-right: min(2vw, 1em);
}
group-scoreboard .score:last-child {
  margin-right: min(5vw, 1em);
}
group-scoreboard .group-member-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  margin-top: 1em;
  background-color: var(--motes-gray);
  border-radius: 50%;
}
group-scoreboard .group-member-image.loading {
  background: linear-gradient(-45deg, #979696, var(--motes-light-gray));
  background-size: 400% 400%;
  animation: gradient 4s ease infinite;
}
group-scoreboard .group-member-image img {
  position: absolute;
  top: 0;
  border-radius: inherit;
}
group-scoreboard .group-member-name {
  min-height: 2.5em;
  margin-top: 0.5em;
  text-align: center;
}
group-scoreboard .group-member-name.loading {
  border-radius: 5px;
  background: linear-gradient(-45deg, #979696, var(--motes-light-gray));
  background-size: 400% 400%;
  animation: gradient 4s ease infinite;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
group-scoreboard .active-member-marker {
  position: absolute;
  margin-top: -33px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: var(--motes-blue);
}
group-scoreboard .active-member-marker svg-icon {
  padding-top: 2px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/group-scoreboard/group-scoreboard.component.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;EAEA,wBAAA;EACA,qBAAA;AADJ;AAII;EACE,aAAA;AAFN;AAQE;EACE,aAAA;AANJ;AAQI;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AANN;AASI;EACE,gBAAA;AAPN;AAUI;EACE,aAAA;AARN;AAYE;;EAEE,kBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,yBAAA;AAXJ;AAaI;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,qDAAA;AAXN;AAeE;EACE,cAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EAEA,sBAAA;AAfJ;AAiBI;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,qEAAA;EACA,6BAAA;AAfR;AAiBQ;EACI,2BAAA;EACA,kBAAA;AAfZ;AAmBI;EACI,kBAAA;AAjBR;AAoBI;EACI,uEAAA;EACA,oBAAA;EACA,yBAAA;AAlBR;AAqBI;EACI,uEAAA;EACA,sBAAA;EACA,yBAAA;AAnBR;AAuBI;EACI,uEAAA;EACA,sBAAA;EACA,yBAAA;AArBR;AAyBE;EACE;IACI,UAAA;IACA,2BAAA;EAvBN;EAyBE;IACI,UAAA;EAvBN;EAyBE;IACI,0BAAA;IACA,UAAA;EAvBN;EAyBE;IACI,UAAA;IACA,0BAAA;EAvBN;EAyBE;IACI,UAAA;IACA,0BAAA;EAvBN;EAyBE;IACI,UAAA;IACA,0BAAA;EAvBN;AACF;AA0BE;EACE;IACI,UAAA;IACA,0BAAA;EAxBN;EA0BE;IACI,0BAAA;IACA,UAAA;EAxBN;EA0BE;IACI,UAAA;IACA,2BAAA;EAxBN;EA0BE;IACI,UAAA;IACA,2BAAA;EAxBN;AACF;AA2BE;EACE,YAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;AA1BJ;AA6BE;EACE,uBAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;AA3BJ;AA8BE;EACE,2BAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;AA7BJ;AA+BI;EACE,qEAAA;EACA,0BAAA;EACA,oCAAA;AA7BN;AAgCI;EACE,kBAAA;EACA,MAAA;EACA,sBAAA;AA9BN;AAkCE;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AAhCJ;AAkCI;EACE,kBAAA;EACA,qEAAA;EACA,0BAAA;EACA,oCAAA;AAhCN;AAoCE;EACE;IACE,2BAAA;EAlCJ;EAoCE;IACE,6BAAA;EAlCJ;EAoCE;IACE,2BAAA;EAlCJ;AACF;AAqCE;EACE,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;AAnCJ;AAoCI;EACI,gBAAA;AAlCR","sourcesContent":["group-scoreboard {\n  * {\n    box-sizing: border-box;\n    // Hide scrollbar for IE, Edge and Firefox\n    -ms-overflow-style: none; // IE and Edge\n    scrollbar-width: none; // Firefox\n\n    // Hide scrollbar for Chrome, Safari and Opera\n    ::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  // Styling of <simple-select>\n  // ! Should be redundant in generic modal\n  .simple-select {\n    display: flex;\n\n    .overlay-container {\n      width: 100%;\n      max-height: 100%;\n      margin-top: 0;\n    }\n\n    .select-box {\n      max-height: 90vh;\n    }\n\n    hr {\n      display: none;\n    }\n  }\n\n  h3,\n  span.subheading {\n    text-align: center;\n    margin-bottom: 1rem;\n  }\n\n  h3 {\n    text-transform: uppercase;\n\n    &::after {\n      content: \"\";\n      display: block;\n      margin: auto;\n      width: 30%;\n      padding-top: 0.5rem;\n      border-bottom: 2px solid var(--motes-highlight-color);\n    }\n  }\n\n  span.subheading {\n    display: block;\n  }\n\n  .waiting-box {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    top: 45%;\n    font-size: 18px;\n    left: 0;\n    right: 0;\n\n    --animation-time: 2.7s;\n\n    .persons-loading {\n        display: flex;\n        position: relative;\n        justify-content: center;\n        font-size: 34px;\n        margin-bottom: 2px;\n        animation: loading-people-out var(--animation-time) ease-out infinite;\n        animation-fill-mode: forwards;\n\n        svg-icon {\n            transform: translateY(15px);\n            position: relative;\n        }\n    }\n\n    .waiting-label {\n        text-align: center;\n    }\n\n    .persons-loading svg-icon:nth-child(1) {\n        animation: loading-people-in var(--animation-time) ease-in-out infinite;\n        animation-delay: 0ms;\n        animation-fill-mode: both;\n    }\n    \n    .persons-loading svg-icon:nth-child(2) {\n        animation: loading-people-in var(--animation-time) ease-in-out infinite;\n        animation-delay: 450ms;\n        animation-fill-mode: both;\n\n    }\n    \n    .persons-loading svg-icon:nth-child(3) {\n        animation: loading-people-in var(--animation-time) ease-in-out infinite;\n        animation-delay: 900ms;\n        animation-fill-mode: both;\n    }\n  }\n\n  @keyframes loading-people-in {\n    0% {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n    8% {\n        opacity: 1;\n    }\n    10% {\n        transform: translateY(0px);\n        opacity: 1;\n    }\n    65% {\n        opacity: 1;\n        transform: translateY(0px);\n    }\n    66% {\n        opacity: 0;\n        transform: translateY(0px);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(0px);\n    }\n  }\n\n  @keyframes loading-people-out {\n    0% {\n        opacity: 1;\n        transform: translateY(0px);\n    }\n    60% {\n        transform: translateY(0px);\n        opacity: 1;\n    }\n    70% {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(12px);\n    }\n  }\n\n  scoreboard-column {\n    height: 30vh;\n  }\n\n  .scoreboard {\n    display: flex;\n    flex-direction: row;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    margin: auto;\n    width: fit-content;\n    max-width: 100%;\n  }\n\n  .score {\n    width: min(25vw, 100px);\n    flex-shrink: 0;\n    margin-left: min(2vw, 1em);\n    margin-right: min(2vw, 1em);\n  }\n\n  .score:last-child {\n    margin-right: min(5vw, 1em);\n  }\n\n  .group-member-image {\n    position: relative;\n    width: 100%;\n    padding-top: 100%;\n    margin-top: 1em;\n    background-color: var(--motes-gray);\n    border-radius: 50%;\n\n    &.loading {\n      background: linear-gradient(-45deg, #979696, var(--motes-light-gray));\n      background-size: 400% 400%;\n      animation: gradient 4s ease infinite;\n    }\n\n    img {\n      position: absolute;\n      top: 0;\n      border-radius: inherit;\n    }\n  }\n\n  .group-member-name {\n    min-height: 2.5em;\n    margin-top: 0.5em;\n    text-align: center;\n\n    &.loading {\n      border-radius: 5px;\n      background: linear-gradient(-45deg, #979696, var(--motes-light-gray));\n      background-size: 400% 400%;\n      animation: gradient 4s ease infinite;\n    }\n  }\n\n  @keyframes gradient {\n    0% {\n      background-position: 0% 50%;\n    }\n    50% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: 0% 50%;\n    }\n  }\n\n  .active-member-marker {\n    position: absolute;\n    margin-top: -33px;\n    right: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-size: 24px;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    background-color: var(--motes-blue);\n    svg-icon {\n        padding-top: 2px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
